module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "display-1"
  }, [_vm._v(":( 404")]), _vm._v(" "), _c('h4', {
    staticClass: "display-4"
  }, [_vm._v("Não encontrado")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df8e3052","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Error/Error.vue
// module id = 355
// module chunks = 1